<script setup lang="ts">
import { PhGlobeHemisphereEast, PhMapTrifold } from '@phosphor-icons/vue'

import LocationControl from '@/components/location/LocationControl.vue'
import type { BasemapKind } from '@/components/map/mapMode'

defineProps<{
  basemap: BasemapKind
  isLocating: boolean
  error: string
}>()

defineEmits<{
  toggleBasemap: []
  locate: []
}>()
</script>

<template>
  <!--
    The column positions itself rather than making each of the five map screens
    repeat `absolute right-3 bottom-8`. `bottom-8` is not arbitrary: it clears
    Leaflet's attribution bar, which is ~18px tall and pinned to the bottom edge
    — at bottom-3 the controls sat on top of it. Every caller's map container is
    already `relative`, and nothing here may be `fixed`: the overlay is scoped to
    the map, which itself sits inside the phone frame.
  -->
  <div class="pointer-events-none absolute right-3 bottom-8 z-10 flex flex-col items-end gap-2">
    <!-- Map-specific notices (the home map's zoom floor and cap hints) stack
         above the buttons in the same column. -->
    <slot />

    <button
      type="button"
      class="pointer-events-auto flex size-11 items-center justify-center bg-background text-foreground ring-1 ring-foreground/25 transition-colors hover:bg-muted"
      :aria-label="basemap === 'map' ? 'Switch to satellite imagery' : 'Switch to map view'"
      :aria-pressed="basemap === 'satellite'"
      @click="$emit('toggleBasemap')"
    >
      <PhGlobeHemisphereEast v-if="basemap === 'map'" class="size-5" />
      <PhMapTrifold v-else class="size-5" />
    </button>

    <LocationControl :is-locating="isLocating" :error="error" @locate="$emit('locate')" />
  </div>
</template>
